import { connect } from 'react-redux';
import OfferDetailsTopBarSponsoredItems from '../components/OfferDetailsTopBarSponsoredItems';

export default connect(
  state => {
    const { betaFeatures } = state.user;

    return ({
      shouldBeDisplayed: betaFeatures.includes('OFFER_DETAILS_TOP_CAROUSEL'),
    });
  },
)(OfferDetailsTopBarSponsoredItems);
